import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SocialLoginButtonFacebookComponent } from './social-login-button.facebook.component';
import { TranslateModule } from '@ngx-translate/core';
import { Angular2SocialLoginModule } from 'angular2-social-login';
import { StoreConfigurationsService } from '../../../services/store-configurations.service';

@NgModule({
    declarations: [
        SocialLoginButtonFacebookComponent
    ],
    imports: [
        BrowserModule,
        CommonModule,
        TranslateModule,
        Angular2SocialLoginModule
    ],
    exports: [
        SocialLoginButtonFacebookComponent
    ]
})
export class SocialLoginButtonFacebookModule {
    constructor(
        protected storeConfigurations: StoreConfigurationsService
    ) {
        this.storeConfigurations.dataLoaded$.subscribe((data) => {
            if (
                data['facebook-app-id'] !== undefined
                && data['facebook-app-id'] !== null
            ) {
                Angular2SocialLoginModule.loadProvidersScripts({
                    'facebook': {
                        'clientId': data['facebook-app-id'],
                        'apiVersion': 'v4.0'
                    }
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/shared/components/social-login-button/facebook/social-login-button.facebook.module.ts